import "core-js/modules/web.dom.iterable";
//
//
//
//
import barLineChart from '@/components/bigDataChart/barLineChart';
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryCurveAnalysisSx } from '@/api/api';
import moment from 'moment'; // import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'waterStatistics',
  //   mixins: [listenMapChange],
  created: function created() {
    this.queryWarnStatistics();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  components: {
    barLineChart: barLineChart
  },
  methods: {
    queryWarnStatistics: function queryWarnStatistics() {
      var _this = this;

      var dateTime = new Date();
      var that = this;
      var yAxisData1 = [];
      var yAxisData2 = [];
      var yAxisData3 = [];
      var yAxisData4 = [];
      var xAxisData = [];
      queryCurveAnalysisSx({
        factorCategory: '12',
        id: '12',
        type: 0 // etime: moment(dateTime).format("YYYY-MM-DD"),
        // stime: moment(dateTime - 1000 * 60 * 60 * 24 * 7).format("YYYY-MM-DD"),

      }).then(function (res) {
        if (res.success) {
          if (res.result.data.length) {
            res.result.data.forEach(function (element) {
              yAxisData1.push(element.dataCodeMap['u20401'].value);
              yAxisData2.push(element.dataCodeMap['u20201'].value);
              yAxisData3.push(element.dataCodeMap['u20101'].value);
              yAxisData4.push(element.dataCodeMap['u20301'].value);
              xAxisData.push(element.dateStr);
            });
          } else {
            xAxisData = ['2020-10-31 01', '2020-10-31 02', '2020-10-31 03', '2020-10-31 04'];
            yAxisData1 = [0, 0, 0, 0];
            yAxisData2 = [0, 0, 0, 0];
            yAxisData3 = [0, 0, 0, 0];
            yAxisData4 = [0, 0, 0, 0];
          }

          var data = {
            color: ['#8B5CFF', '#00CA69', '#898b37', '#ff9900'],
            title: ['面积', '流量', '水位', '流速'],
            xAxisData: xAxisData,
            yAxisList: [yAxisData1, yAxisData2, yAxisData3, yAxisData4],
            unit: '',
            height: 150
          };

          _this.$refs.chart3.initBarLineChart(data);
        }
      });
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWarnStatistics(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWarnStatistics(value, this.currentProjectId)
  //     },
  //   },

};